import { WSPill, WSPillProps } from "@wingspanhq/fe-component-library";
import React from "react";
import { ClientPayableDisplayStatus } from "../../types";

const PILL_BY_STATUS: Record<ClientPayableDisplayStatus, WSPillProps> = {
  unpaid: { theme: "warning", text: "Awaiting payment" },
  overdue: { theme: "error", text: "Overdue" },
  inTransit: { theme: "blue", text: "In transit" },
  paid: { theme: "success", text: "Paid" },
  cancelled: { theme: "neutral", text: "Cancelled" },
  refunded: { theme: "neutral", text: "Refunded" }
};

type Props = {
  status: ClientPayableDisplayStatus;
};

// Presentational only — takes the normalized display status so a future
// guest-flow sibling (a different source, same ClientPayableDisplayStatus)
// can render through this unchanged.
export const ClientPayableStatusBadge: React.FC<Props> = props => (
  <WSPill {...PILL_BY_STATUS[props.status]} />
);
